(function () {
  var ROOT_SELECTOR = ".miracle-essence-mist-swiper";
  var SWIPER_SELECTOR = ".new-common-product-swiper-container.swiper";
  var MAX_WAIT = 5000;
  var PC_STEP_RATIO = 0.66;
  var TABLET_DRAG_MIN = 851;
  var TABLET_DRAG_MAX = 1019;
  var PC_DRAG_MIN = 1020;

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getSwiper(root) {
    if (!root) return null;
    var el = root.querySelector(SWIPER_SELECTOR);
    return el && el.swiper ? el.swiper : null;
  }

  function getSlides(root) {
    return Array.prototype.slice.call(root.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)"));
  }

  function getCardWidth(root) {
    var slide = root.querySelector(".swiper-slide:not(.swiper-slide-duplicate)");
    if (!slide) slide = root.querySelector(".swiper-slide");
    return slide ? slide.getBoundingClientRect().width : 0;
  }

  function getStep(root) {
    var cardWidth = getCardWidth(root);
    return window.matchMedia("(min-width: 850.1px)").matches ? cardWidth * PC_STEP_RATIO : cardWidth;
  }

  function isTabletDragRange() {
    return window.innerWidth >= TABLET_DRAG_MIN && window.innerWidth <= TABLET_DRAG_MAX;
  }

  function isDragPatchRange() {
    return isTabletDragRange() || window.innerWidth >= PC_DRAG_MIN;
  }

  function getTabletDragStep() {
    return window.innerWidth * 0.25;
  }

  function getDragStep(root) {
    return isTabletDragRange() ? getTabletDragStep() : getStep(root);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function syncButtons(root, index, maxIndex) {
    var prev = root.querySelector(".button-content .swiper-button-prev");
    var next = root.querySelector(".button-content .swiper-button-next");
    var buttons = [prev, next];

    buttons.forEach(function (button) {
      if (!button) return;
      button.classList.remove("swiper-button-disabled");
      button.removeAttribute("aria-disabled");
      button.removeAttribute("disabled");
    });

    if (prev && index <= 0) prev.classList.add("miracle-essence-button-disabled");
    if (next && index >= maxIndex) next.classList.add("miracle-essence-button-disabled");
    if (prev && index > 0) prev.classList.remove("miracle-essence-button-disabled");
    if (next && index < maxIndex) next.classList.remove("miracle-essence-button-disabled");
  }

  function getCurrentIndex(root, swiper, step) {
    var current = typeof swiper.getTranslate === "function" ? swiper.getTranslate() : swiper.translate || 0;
    var index = Math.round(Math.abs(current) / step);
    if (typeof root.dataset.miracleEssenceIndex !== "undefined") {
      index = parseInt(root.dataset.miracleEssenceIndex, 10);
    }
    return isNaN(index) ? 0 : index;
  }

  function setIndex(root, swiper, index, animate, stepOverride) {
    var step = stepOverride || getStep(root);
    var maxIndex = Math.max(getSlides(root).length - 1, 0);
    if (!step || !maxIndex) return;

    index = clamp(index, 0, maxIndex);
    root.dataset.miracleEssenceIndex = String(index);

    var next = -index * step;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (typeof swiper.setTransition === "function") swiper.setTransition(animate ? 300 : 0);
    if (typeof swiper.setTranslate === "function") swiper.setTranslate(next);
    if (typeof swiper.updateProgress === "function") swiper.updateProgress(next);
    if (typeof swiper.updateActiveIndex === "function") swiper.updateActiveIndex(index);
    if (typeof swiper.updateSlidesClasses === "function") swiper.updateSlidesClasses();
    syncButtons(root, index, maxIndex);
  }

  function moveByCard(root, swiper, direction) {
    var step = getStep(root);
    if (!step) return;

    var index = getCurrentIndex(root, swiper, step);
    setIndex(root, swiper, index + (direction === "prev" ? -1 : 1), true);
  }

  function patchDrag(root, swiper) {
    if (!swiper || typeof swiper.on !== "function") return;

    var dragStartTranslate = 0;
    var dragStartIndex = 0;

    swiper.on("touchStart", function () {
      if (!isDragPatchRange()) return;

      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;

      var step = getDragStep(root);
      dragStartTranslate = typeof swiper.getTranslate === "function" ? swiper.getTranslate() : swiper.translate || 0;
      dragStartIndex = Math.round(Math.abs(dragStartTranslate) / step);
      root.dataset.miracleEssenceIndex = String(dragStartIndex);
    });

    swiper.on("touchEnd", function () {
      if (!isDragPatchRange()) return;

      window.setTimeout(function () {
        var step = getDragStep(root);
        var current = typeof swiper.getTranslate === "function" ? swiper.getTranslate() : swiper.translate || 0;
        var delta = current - dragStartTranslate;
        var direction = Math.abs(delta) < 10 ? 0 : delta < 0 ? 1 : -1;

        setIndex(root, swiper, dragStartIndex + direction, true, step);
      }, 0);
    });
  }

  function patch(root, swiper) {
    var swiperEl = root.querySelector(SWIPER_SELECTOR);
    if (!swiperEl || swiperEl.dataset.miracleEssenceStepFixed === "true") return;

    swiperEl.dataset.miracleEssenceStepFixed = "true";

    var prev = root.querySelector(".button-content .swiper-button-prev");
    var next = root.querySelector(".button-content .swiper-button-next");

    if (prev) {
      prev.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        moveByCard(root, swiper, "prev");
      }, true);
    }

    if (next) {
      next.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        moveByCard(root, swiper, "next");
      }, true);
    }

    syncButtons(root, getCurrentIndex(root, swiper, getStep(root)), Math.max(getSlides(root).length - 1, 0));
    patchDrag(root, swiper);

    window.addEventListener("resize", function () {
      if (typeof swiper.update === "function") swiper.update();
      setIndex(root, swiper, getCurrentIndex(root, swiper, getStep(root)), false);
    });
  }

  onReady(function () {
    var start = Date.now();
    (function wait() {
      var root = getRoot();
      var swiper = getSwiper(root);
      if (root && swiper) {
        patch(root, swiper);
        return;
      }
      if (Date.now() - start < MAX_WAIT) {
        window.setTimeout(wait, 80);
      }
    })();
  });
})();
